import * as Yup from "yup";

// Types
export type SignInFormInputs = {
  email: string;
  password: string;
};

// Validation Schema
export const validationSchema = Yup.object({
  email: Yup.string().required("Email Address is required."),
  password: Yup.string().required("Password is required."),
});

// Initial Form Values
export const initialValues: SignInFormInputs = {
  email: "",
  password: "",
};

// Role-based navigation mapping
export const ROLE_ROUTES: Record<string, string> = {
  "4": "/admin/dashboard",
  "7": "/admin/unfinished-users",
  "1": "/customer/dashboard",
  "6": "/translator/projects",
  "3": "/manager/dashboard",
};

export const getRouteByRole = (roleId: string): string => {
  return ROLE_ROUTES[roleId] || "/customer/dashboard";
};
